import { Directive, HostBinding, Input } from '@angular/core';

@Directive(
    {
        selector: '[scIndeterminateCheckbox]',
        standalone: false
    })
export class IndeterminateCheckboxDirective {

    @HostBinding('class.sc-indeterminate-checkbox')
    public middleStateClass: any;

    @Input()
    public set scIndeterminateCheckbox(value: boolean) {
        this.middleStateClass = value;
    }
}
